var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 2.75C5.10051 2.75 2.75 5.10051 2.75 8C2.75 10.8995 5.10051 13.25 8 13.25C10.8995 13.25 13.25 10.8995 13.25 8C13.25 5.10051 10.8995 2.75 8 2.75ZM8 9.875C8.31066 9.875 8.5625 10.1268 8.5625 10.4375C8.5625 10.7482 8.31066 11 8 11C7.68934 11 7.4375 10.7482 7.4375 10.4375C7.4375 10.1268 7.68934 9.875 8 9.875ZM8 5C8.18409 5 8.33721 5.13266 8.36896 5.30759L8.375 5.375V8.75C8.375 8.95711 8.20711 9.125 8 9.125C7.81591 9.125 7.66279 8.99234 7.63104 8.81741L7.625 8.75V5.375C7.625 5.16789 7.79289 5 8 5Z",
    fill: "#D0021B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFormIcon);
export default __webpack_public_path__ + "static/media/warningFormIcon.20308de5f9886defdee9de4d149ef134.svg";
export { ForwardRef as ReactComponent };